export const leadingZero = (num: number): number | string => num < 10 ? `0${ num }` : num;

export function splitThousands (value: string | number): string | number {
  value = Number.parseInt(String(value), 10);

  if (isNaN(value)) {
    return value;
  }

  return value
    .toLocaleString('ru-RU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
}

export function prettyPhone (phone: string): string {
  return phone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3-$4-$5');
}

export function prettyPhoneWithParenthesis (phone: string): string {
  return phone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5');
}

export function currency (value: number): string | undefined {
  if (isNaN(value)) {
    console.warn('[number-utils currency] "value" must be a Number!');

    return;
  }

  return Number(value)
    .toLocaleString('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
}

export function declOfNum (number: number, titles: string[]): string {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}

export function rooms (count: number, suffix: string): string {
  if (!count) {
    return 'Студия';
  }

  return `${ count }-${ suffix }`;
}

export function quarterToRoman (value: number): string {
  if (!Number.isInteger(value)) {
    console.warn('[number-utils quarterToRoman] "value" must be an Integer!');

    return '';
  }

  return ['I', 'II', 'III', 'IV'][--value % 4];
}
